import { render, staticRenderFns } from "./ModalChangeFreePick.vue?vue&type=template&id=0c636580"
import script from "./ModalChangeFreePick.vue?vue&type=script&lang=js"
export * from "./ModalChangeFreePick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports